/*
 * @Date: 2026-03-30 09:38:53
 * @LastEditTime: 2026-04-08 14:55:41
 */
import request from '@/utils/request'

export default class AjaxAuthService {
  /**下单 */
  static order(data: any): Promise<any> {
    return request.post('/app/h5/placeOrderPh', data)
  }
  /**模糊获取驿站信息 */
  static detail(data: any): Promise<any> {
    return request.post('/app/station/h5/detail', data)
  }
  /**数据字典值查询 */
  static getDictValue(data: any): Promise<any> {
    return request.post('/app/h5/getDictValue', data)
  }
  /**上传图片接口 */
  // static uploadImg(data: any): Promise<any> {
  //   return request.upload('/architecture/upload', data)
  // }
  /**上传图片接口 */
  static getUploadUrl(data: any): Promise<any> {
    return request.post('/app/h5/getUploadUrl', data)
  }
  /**获取保价费 */
  static orderData(data: any): Promise<any> {
    return request.post('/app/h5/orderData', data)
  }
  /**校验新用户 */
  static checkNewCustomer(data: any): Promise<any> {
    return request.post('/app/h5/checkNewCustomer', data)
  }
  /**获取图形验证码 */
  static getCaptchaMap(data: any): Promise<any> {
    return request.post('/app/h5/getCaptchaMap', data)
  }
  // /**校验图形验证码 */
  // static checkCaptcha(data: any): Promise<any> {
  //   return request.post('/h5/checkCaptcha', data)
  // }
  /**短信取消接口 */
  static smsCancel(data: any): Promise<any> {
    return request.post('/app/h5/smsCancel', data)
  }
  /**发送短信 */
  static sendSms(data: any): Promise<any> {
    return request.post('/app/h5/send', data)
  }
  /**获取快递公司列表 */
  static getExpressList(data: any): Promise<any> {
    return request.post('/app/express/h5/listVO', data)
  }
  /**获取网点列表 */
  static queryInfo(data: any): Promise<any> {
    return request.post('/app/h5/station/queryInfo', data)
  }
}
